import React from 'react';
import ErrorIcon from '../../Basic/Icons/ErrorIcon.mjs';
import SuccessIcon from '../../Basic/Icons/SuccessIcon.mjs';
import { StyledModalContainer, StyledIconContainer } from './StatusMessageModal.styles.mjs';

var Status;
(function (Status) {
    Status["SUCCESS"] = "success";
    Status["ERROR"] = "error";
})(Status || (Status = {}));
const StatusIconMap = {
    [Status.SUCCESS]: SuccessIcon,
    [Status.ERROR]: ErrorIcon
};
const StatusMessageModal = ({ title, status, onClose }) => {
    const StatusIcon = StatusIconMap[status];
    return (React.createElement(StyledModalContainer, { enableOverlay: true, title: title, onClose: onClose },
        React.createElement(StyledIconContainer, null,
            React.createElement(StatusIcon, null))));
};

export { Status, StatusMessageModal as default };
//# sourceMappingURL=StatusMessageModal.mjs.map
